export const CONTACT_US_DESCRIPTION_MAX_CHARACTERS = 300;
export const CONTACT_US_DESCRIPTION_MIN_CHARACTERS = 6;

export const SALESFORCE_API_ENUMS = {
  TICKET_STATUS_NEW  : 'New',
  TICKET_ORIGIN      : 'Web SPA'
};

export const SALESFORCE_DEVICE_PLATFORM_ENUMS = {
  SMARTPHONE: 'Smart Phone',
  DESKTOP   : 'Desktop'
};

export const INIT_FORM_DATA_TYPES = {
  SURVEY_ISSUE         : 'surveyIssue',
  PULSE                : 'pulse',
  EDIT_NAME            : 'editName',
  MAX_REDEMPTION_POINTS: 'maxRedemptionPoints',
  EDIT_ZIP_CODE        : 'editZipCode',
};

export const HELP_PAGE_QUERY_PARAMS = {
  TYPE         : 'type',
  SURVEY_ID    : 'surveyId',
  SURVEY_STATUS: 'surveyStatus',
  ZIP_CODE     : 'zipCode'
};
